// Models
import { LookUpResponse } from '../models';

export namespace LookupActions {
	export class GetAll {
		static readonly type = '[Lookup] Get Lookups';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Company] Set Lookups';
		constructor(public lookups: LookUpResponse) {}
	}
}
